import {
    Control,
    FieldErrors,
    UseFormClearErrors,
    UseFormSetError,
    UseFormSetValue,
    UseFormWatch,
} from 'react-hook-form';

// Any type will be handled later
export interface JavascriptTransformFormProps {
    control: Control<any>;
    errors: FieldErrors<any>;
    watch: UseFormWatch<any>;
    setValue: UseFormSetValue<any>;
    clearErrors: UseFormClearErrors<any>;
    setError: UseFormSetError<any>;
}

export const javascriptTransformFormStyles = {
    popperStyles: {
        width: '186px',
        height: '40px',
    },
    transformLabelContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    accordionTransformLabelContainer: {
        mx: 2,
    },
    actionsContainer: {
        display: 'flex',
        alignItems: 'center',

        '& .icon-button': {
            height: '20px',
            width: '20px',
        },
    },
    accordionActionsContainer: {
        mr: 4.5,
    },
    dragAndDropDialogStyles: {
        '& .MuiPaper-root': {
            width: '663px',
            '#dialog-title-container': {
                minHeight: '68px',
            },
            '& .MuiDialogContent-root': {
                p: '0px 66px 16px 66px',
                overflow: 'hidden',
                '&>.MuiGrid-root': {
                    '&>.MuiGrid-root:nth-child(1)': {
                        '&>p': {
                            display: 'none',
                        },
                    },
                },
            },
            '& .MuiDialogActions-root': {
                pb: 2,
                pr: 2.5,
            },
        },
    },
};
